import { InfiniteScroll as IS } from './InfiniteScroll'
import { CenteredSpinner } from './primitives'

export const InfiniteScroll = {
  Root: IS,
  Spinner: CenteredSpinner
}
